import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Table, TableLazyLoadEvent } from "primeng/table";
import { SkuAge } from "../../core/enums";
import { StateService } from "../../services/state.service";
import { groupBy } from "../../utils";
import { KeyValue } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-pho-table-v2",
  templateUrl: "./pho-table-v2.component.html",
  styleUrls: ["./pho-table-v2.component.scss"],
})
export class PhoTableV2Component implements OnInit, OnChanges {
  @Input() tableColumns: any[] = [];
  @Input() tableData: any[] = [];
  @Input() tableActions: any[] = [];
  @Input() dataFrom?: string;
  @Input() skeletonLoader: boolean = false;
  @Input() showPagination: boolean = false;
  @Input() showDynamicPagination: boolean = false;
  @Input() topHeader: any[] = [];
  @Input() showFilters: boolean = false;
  @Input() groupRowsBy: string = "";
  @Input() subHeaderColumns: any[] = [];
  @Input() scrollFlag: boolean = false;
  @Input() scrollHeight: string = "";
  @Input() rowFlag!: number;
  @Input() styleClassName: string = "";
  @Input() virtualScrollFlag: boolean = false;
  @Input() textAlign: string = "";
  @Input() isSelectableTable?: boolean = false;
  @Input() isSelectableTableFrozen: boolean = false;
  @Input() rowsPerPage?: number = 5;
  @Input() rowClick: boolean = false;
  @Input() isVotingClosed: boolean = false;
  @Input() selectionMode: any = "";
  @Input() totalRecords!: number;
  @Input() uniqueKey: string = "";
  @Output() emitTableAction = new EventEmitter<any>();
  @Output() emitTableSelection = new EventEmitter<any>();
  @Output() changePage = new EventEmitter<any>();
  @Output() emitRowSelection = new EventEmitter<any>();
  @Output() emitTableRowClick = new EventEmitter<any>();
  @Output() emitFilter = new EventEmitter<any>();
  @Input() paginationFirst: number = 0;
  @Input() lazyLoad: ((page: number, perPage: number) => void) | null = null;
  @Input() paginationList: any = [];
  @Input() accessType: any;

  selectedItems: any[] = [];
  skeletonData = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  pagination = {
    limit: 5,
    options: [5, 10, 20, 30],
  };

  skuAge = SkuAge;
  objectKeys = Object.keys;
  selectedRow!: any;
  selectFilterOptions: any[] = [
    { label: "Option 1", value: "option1" },
    { label: "Option 2", value: "option2" },
    { label: "Option 3", value: "option3" },
    { label: "Option 4", value: "option4" },
    { label: "Option 5", value: "option5" },
  ];
  @ViewChild("phoTbl") phoTbl!: Table;
  actionColumnList: any = [];
  overlayDetails: any = {};
  lockAssortment: boolean = false;
  expId!: any;
  showEditIcon: boolean = false;
  hoveredRow: any = null;
  filterSuggestions: any[] = [];
  selectedFilterItem: any;
  currentPage: number = 1;

  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>,
  ): number => {
    return 0;
  };
  arrowIndicatorColumns: string[] = [
    "total_maco",
    "total_volume",
    "maco_hl",
    "maco_margin",
    "growth",
    "total_revenue",
    "sku_ranking_score",
    "volume_retained",
    "share_abi",
    "revenue_uplift",
    "maco_uplift",
  ];
  isOlderExperiment: boolean = false;
  simulateDropdownOptions: any = [
    { label: "Delist", value: "Delist" },
    { label: "Delist Confirmed", value: "Delist Confirmed" },
  ];
  notAnalysedDropdownOptions: any = [
    { label: "Not Analyzed", value: "Not Analyzed" },
  ];
  constructor(
    private stateService: StateService,
    private router: Router,
  ) {
    this.stateService.getAssortmentLock.subscribe((newValue: any) => {
      this.setAssortmentStepsLock();
    });
  }

  getSubColumnBgColor(colKey: string, colIndex?: number): string {
    let subCol = this.subHeaderColumns.find((sc) => sc.value === colKey);
    if (!subCol && colIndex !== undefined && this.subHeaderColumns[colIndex]) {
      subCol = this.subHeaderColumns[colIndex];
    }
    return subCol?.cellBgColor || "";
  }

  ngOnInit(): void {
    this.expId = sessionStorage.getItem("expId");
    this.setAssortmentStepsLock();
    this.isOlderExperiment =
      sessionStorage.getItem("expVersion") === "V1" ||
      sessionStorage.getItem("expVersion") === "V2";
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.tableData) {
      this.prepareTableFilterOptions(changes.tableData.currentValue);

      this.paginationFirst = 0;

      const savedPage = sessionStorage.getItem("currentPage");
      if (savedPage && this.dataFrom === "opr") {
        this.paginationFirst = (+savedPage - 1) * 10;
      } else {
        this.paginationFirst = 0;
      }
    }

    if (changes && changes.paginationList) {
      this.pagination = {
        limit: this.paginationList[0],
        options: this.paginationList,
      };
      this.rowFlag = this.paginationList[0];
      this.paginationFirst = 0;
    }
    this.selectedItems = [];
    if (changes && changes.showFilters) {
      this.phoTbl?.clear();
    }
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    if (this.lazyLoad) {
      const page = event.first! / event.rows! + 1;
      this.lazyLoad(page, event.rows!);
    }
  }

  onTableAction(data: any, action: any) {
    if (!this.router.url.includes("ppr-summary")) {
      event?.stopPropagation();
    }
    this.emitTableAction.emit({ ...data, ...action });
  }

  onSelectAllRows(event: any) {
    this.emitTableSelection.emit(this.selectedItems);
  }

  checkRow(event: any) {
    this.emitTableSelection.emit(this.selectedItems);
  }
  onPage(event: any) {
    this.changePage.emit({ event });
  }
  toSelectedRow(event: Event, item: any) {
    if (this.dataFrom === "simulation-parent-table") {
      this.selectedRow = item;
      this.emitTableSelection.emit({
        type: "row_select",
        data: item,
      });
    }

    if (this.rowClick) {
      this.emitRowSelection.emit(item);
    }

    if (
      this.dataFrom === "user-voting" ||
      this.dataFrom === "opr" ||
      this.dataFrom === "exe-summary-sku-details" ||
      this.dataFrom === "global-dashboard"
    ) {
      this.emitTableRowClick.emit({
        type: "row_select",
        data: item,
      });
    }
  }

  getString(input: any) {
    return String(input);
  }

  clear(table: Table) {
    table.clear();
  }

  onTableDropdownChange(selectedValue: any, rowData: any) {
    if (this.dataFrom === "executuve-summary") {
      rowData.recommendation = selectedValue;
    } else {
      rowData.simulation = selectedValue;
    }
    this.emitTableSelection.emit({
      type: "dropdown_change",
      dataFrom: this.dataFrom,
      data: rowData,
    });
  }

  onInputBlur(selectedValue: any, rowData: any) {
    if (selectedValue !== rowData.remarks) {
      rowData.remarks = selectedValue;
      this.emitTableSelection.emit({
        type: "input_blur",
        dataFrom: this.dataFrom,
        data: rowData,
      });
    }
  }

  nParseFloat(data: any, val: any) {
    if (
      data["index"] === "% of Total SCL Delisted" ||
      data["index"] === "% of Total Revenue Delisted" ||
      data["index"] === "% of Total Volume Delisted" ||
      data["index"] === "% of SKUs delisted" ||
      data["index"] === "% of Total MACO Delisted"
    ) {
      if (this.isInt(val)) {
        return this.formatNumber(val) + "%";
      } else if (val && typeof val !== "string" && !this.isInt(val)) {
        const floatVal: any = this.stateService.nParseFloat(val);
        return this.formatNumber(parseFloat(floatVal)) + "%";
      }
    }
    if (typeof val === "string") {
      return val !== "" ? val : "-";
    } else if (this.isInt(val)) {
      return this.formatNumber(val);
    } else if (
      val &&
      typeof val !== "string" &&
      !this.isInt(val) &&
      typeof val !== "object"
    ) {
      const floatVal: any = this.stateService.nParseFloat(val);
      return this.formatNumber(parseFloat(floatVal));
    } else {
      return val || "-";
    }
  }

  isInt(num: any) {
    return Number(num) === num && num % 1 === 0;
  }

  formatNumber(num: number): string {
    if (typeof num !== "number" || !isFinite(num)) return "";
    const [integerPart, decimalPart] = Math.abs(num).toString().split(".");
    const safeInteger = integerPart.replace(/\d(?=(\d{3})+$)/g, "$&,");
    return (
      (num < 0 ? "-" : "") +
      safeInteger +
      (decimalPart ? "." + decimalPart : "")
    );
  }
  onCheckedOrUpdated() {
    this.emitRowSelection.emit(this.selectedItems);
  }

  toggleOverlay(actionColumn: any, data: any) {
    this.actionColumnList = actionColumn.actionList;
    this.overlayDetails = data;
  }

  planAction(option: any) {
    this.emitTableAction.emit({ action: option, details: this.overlayDetails });
  }

  prepareTableFilterOptions(response: any) {
    this.tableColumns?.map((each: any) => {
      if (each.filterType === "dropdown") {
        const groupByKeys = groupBy(response, each.value);
        if (groupByKeys) {
          each.filterOptions = Object.keys(groupByKeys).map((each: any) => {
            if (each !== "undefined") {
              return { label: each, value: each };
            }
            return;
          });
        }
      }
    });
  }

  onTableRowClick(event: any) {}

  setAssortmentStepsLock() {
    const lockAssortmentSteps = JSON.parse(
      sessionStorage.getItem("lockAssortment")!,
    );
    if (lockAssortmentSteps) {
      this.lockAssortment = lockAssortmentSteps[this.expId!];
    }
  }

  enableEditing(event: Event, item: any) {
    this.hoveredRow = item;
  }

  disableEdititng(event: Event, item: any) {
    this.hoveredRow = item;
  }

  findFilterOptions(event: any, filterOptions: any) {
    if (event) {
      this.filterSuggestions = filterOptions.filter((each: any) => {
        if (each.value.toLowerCase().includes(event.query.toLowerCase())) {
          return each;
        }
      });
    }
  }

  filterTable(event: any, column: any) {
    const matchMode =
      column?.filterType === "input_text" && column?.filterMatchMode
        ? "contains"
        : "equals";
    this.phoTbl.filter(event.value, column?.value, matchMode);
  }
  clearAutocompleteFilters() {
    this.phoTbl.clear();
  }
  getColor(simulation_output: string): string {
    switch (simulation_output.toLowerCase()) {
      case "delist":
        return "red";
      case "keep":
        return "green";
      case "consult":
        return "#e5b611";
      case "cultivate":
        return "#e5b611";
      default:
        return "black";
    }
  }

  filterSearch(value: string, column: any) {
    this.emitFilter.emit({
      column: column,
      value: value,
    });
  }

  clearSelectedRows() {
    this.selectedItems = [];
  }
  getRecommendationColor(value: string) {
    if (value === "PINC due to low risk" || value === "Price Increase") {
      return "#BF8917";
    } else if (value === "VILC Improvement") {
      return "#788D24";
    } else {
      return "#000000";
    }
  }
  getTypeLabel(value: string) {
    if (value === "PINC due to low risk" || value === "Price Increase") {
      return "(PRICE)";
    } else if (value === "VILC Improvement") {
      return "(VILC)";
    } else {
      return "";
    }
  }
  getSubColumns(column: any) {
    return this.subHeaderColumns.filter((col) => {
      return column.subColumns?.includes(col.value);
    });
  }

  getRecommendationBadgeClass(value: string): string {
    if (!value) return "";
    switch (value.toLowerCase()) {
      case "keep":
        return "badge-keep";
      case "delist":
        return "badge-delist";
      case "accelerate":
        return "badge-accelerate";
      case "optimize":
        return "badge-optimize";
      default:
        return "";
    }
  }
}
